export default "__VITE_ASSET__BPvHtO_o__"